import React from "react";
import { CardMedia, Typography, CardContent, Card, Box, Link as A } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Link } from "react-router-dom";
const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    height: 180,
    boxShadow: "none",
    overflow: "visible",
    padding: 0,
  },
  media: {
    margin: "auto",
    height: "100%",
    width: "auto",
  },
  link: {
    "display": "block",
    "width": "100%",
    "height": "100%",
    "position": "relative",
    "borderRadius": 3,
    "transition": ".3s ease",
    "&:hover, &:focus": {
      boxShadow: "0px 0px 10px rgb(0 0 0 / 35%)",
    },
    "& img": {
      height: 150,
      borderRadius: 3,
      transition: ".3s ease",
      position: "absolute",
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
    },
  },
  content: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: 0,
  },
  description: {
    fontSize: "16px",
    textAlign: "center",
    paddingTop: 0,
    paddingLeft: 8,
    paddingRight: 8,
  },
  title: {
    fontFamily: "Merriweather-Bold, Merriweather sans-serif",
    fontWeight: 700,
    fontSize: "18px",
    marginBottom: 0,
    textAlign: "center",
    paddingBottom: 0,
  },
}));
export const MediaCard = ({
  img,
  title,
  description,
  href,
  useHref,
  id,
  showBeta,
  imageHeight,
}: {
  img: any;
  title: string;
  description: string;
  href: string;
  useHref?: boolean;
  id?: string;
  showBeta?: boolean;
  imageHeight?: number;
}) => {
  const classes = useStyles();

  const titleComponent = (
    <Typography className={classes.title} gutterBottom variant="h3" id={id}>
      {title}
      {showBeta ? (
        <>
          <span> &ndash; </span>
          <span
            style={{
              color: "#AA0033",
            }}
          >
            BETA
          </span>
        </>
      ) : (
        undefined
      )}
    </Typography>
  );

  const cardComponent = (
    <CardMedia
      className={classes.media}
      component="img"
      alt={title}
      src={img}
      style={imageHeight ? { height: imageHeight } : undefined}
    />
  );

  return (
    <Box>
      <Card className={classes.root}>
        {useHref ? (
          <A href={href} id={`${id}-card`} className={classes.link}>
            {cardComponent}
          </A>
        ) : (
          <Link to={href} id={`${id}-card`} className={classes.link}>
            {cardComponent}
          </Link>
        )}
      </Card>
      {titleComponent}
      <CardContent className={classes.content}>
        <Typography className={classes.description} component="p">
          {description}
        </Typography>
      </CardContent>
    </Box>
  );
};
